// extracted by mini-css-extract-plugin
export default {"cursor":"AgentMessage_cursor__cgzbG","blink":"AgentMessage_blink__ra6r+"};